import { render, staticRenderFns } from "./OpenPlatform.vue?vue&type=template&id=08e44852&scoped=true&"
import script from "./OpenPlatform.vue?vue&type=script&lang=js&"
export * from "./OpenPlatform.vue?vue&type=script&lang=js&"
import style0 from "./OpenPlatform.vue?vue&type=style&index=0&id=08e44852&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e44852",
  null
  
)

export default component.exports